import React from "react";

const RESET = "RESET";
const TOGGLE_SHUFFLE = "TOGGLE_SHUFFLE";
const SET_SHOWN_RENDERINGS = "SET_SHOWN_RENDERINGS";
const SET_SELECTED_DESIGNS = "SET_SELECTED_DESIGNS";
const SET_SELECTION_TREE = "SET_SELECTION_TREE";

export const dataControlSettingsActions = {
  RESET,
  TOGGLE_SHUFFLE,
  SET_SHOWN_RENDERINGS,
  SET_SELECTED_DESIGNS,
  SET_SELECTION_TREE
};

const dataControlSettingsState = {
  shuffle: false,
  shownRenderings: {
    photorealisticDesigns: true,
    roomViews: false || window?.flags?.showCinematicRoomRenderings, qualifiedSelection: true
  },
  selectedDesigns: {
    thisDesign: false,
    thisFolder: false,
    allDesigns: true,
    advancedSelection: false
  },
  advancedSelectionTree: { excludedFolders: {} }
};

const dataControlSettingsReducer = (state, action) => {
  switch (action.type) {
    case "RESET":
      return { ...dataControlSettingsState };
    case "SET":
      return { ...action.payload };
    case "TOGGLE_SHUFFLE":
      return !action.payload.precalc
        ? toggleShuffle({ state, payload: action.payload })
        : { ...action.payload.precalc };
    case "SET_SHOWN_RENDERINGS":
      return !action.payload.precalc
        ? setShownRenderings({ state, payload: action.payload })
        : { ...action.payload.precalc };
    case "SET_SELECTED_DESIGNS":
      return !action.payload.precalc
        ? setSelectedDesigns({ state, payload: action.payload })
        : { ...action.payload.precalc };
    case "SET_SELECTION_TREE":
      return !action.payload.precalc
        ? setSelectionTree({ state, payload: action.payload })
        : { ...action.payload.precalc };
    default:
      return state;
  }
};

const toggleShuffle = ({ state, payload }) => {
  return { ...state, shuffle: payload };
};

const setShownRenderings = ({ state, payload }) => {
  let newState = { ...state, shownRenderings: { ...state.shownRenderings, ...payload } };
  let qualifiedSelection = Object.entries(newState.shownRenderings).some(
    c => c[0] !== "qualifiedSelection" && c[1] === true
  );
  return {
    ...newState,
    shownRenderings: { ...newState.shownRenderings, qualifiedSelection: qualifiedSelection }
  };
};

const setSelectedDesigns = ({ state, payload }) => {
  let newselectedDesigns = { ...state.selectedDesigns };
  Object.keys(newselectedDesigns).forEach(key => {
    return (newselectedDesigns[key] = payload[key] ? true : false);
  });
  return {
    ...state,
    selectedDesigns: { ...newselectedDesigns }
  };
};

const setSelectionTree = ({ state, payload }) => {
  return {
    ...state,
    advancedSelectionTree: { ...payload }
  };
};

export const dataControlSettingsReducerHandlers = {
  toggleShuffle,
  setShownRenderings,
  setSelectedDesigns
};
// dispatch reducer as context

const StateContext = React.createContext();
const DispatchContext = React.createContext();

function DataControlSettingsProvider({ children }) {
  const [state, dispatch] = React.useReducer(dataControlSettingsReducer, dataControlSettingsState);
  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
    </StateContext.Provider>
  );
}

function useDataControlSettingsState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      "useDataControlSettingsState must be used within a DataControlSettingsProvider"
    );
  }
  return context;
}
function useDispatchDataControlSettings() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      "useDispatchDataControlSettings must be used within a DataControlSettingsProvider"
    );
  }
  return context;
}
export { DataControlSettingsProvider, useDataControlSettingsState, useDispatchDataControlSettings };
